import { SETTINGS_PANEL_ORDER, DESIGN_PROPERTY_CATALOG } from '@mts/shared/blockDesign';

export const CONTENT_EDITOR_INSPECTOR_SECTIONS = Object.freeze([
  ['content','Content'], ['media','Media'], ['layout','Layout'],
  ['typography','Typography'], ['colors','Colors / Background'],
  ['dimensions','Spacing / Dimensions'], ['border','Border and Shadow'],
  ['interactions','Interactions'], ['advanced','Advanced / Template'],
]);

export function presentContentEditorSettings(definition, type) {
  const groups = {};
  for (const category of SETTINGS_PANEL_ORDER) for (const setting of definition.settings[category] || []) {
    let section = category === 'general' ? 'content' : category === 'ai-content' ? 'advanced' : category;
    if (type === 'hero') {
      if (['imageUrl','alt'].includes(setting.key)) section = 'media';
      if (['alignment','overlay','height'].includes(setting.key)) section = 'layout';
    }
    const label = type === 'hero' && setting.key === 'height' ? 'Height preset' : type === 'column' && setting.key === 'width' ? 'Width preset' : setting.label;
    (groups[section] ||= []).push({ ...setting, label });
  }
  return CONTENT_EDITOR_INSPECTOR_SECTIONS.filter(([id]) => groups[id]?.length).map(([id,label]) => ({ id, label, settings: groups[id] }));
}

export function contentEditorStyleSection(property) {
  if (['color','backgroundColor','backgroundImage'].includes(property)) return 'colors';
  const panel = DESIGN_PROPERTY_CATALOG[property].panel;
  return panel === 'spacing' ? 'dimensions' : panel;
}

export function contentEditorEmailSection(type, key) {
  if (['src','alt'].includes(key)) return 'media';
  if (['href','destinationType','hrefVariable'].includes(key)) return 'interactions';
  if (key === 'trackingLabel') return 'advanced';
  if (key === 'tone') return 'colors';
  if (['alignment','width','widthPreset','size','spacing','style','icon','iconPosition'].includes(key)) return 'layout';
  return 'content';
}

export function contentEditorStyleLabel(property) {
  return property.replace(/([A-Z])/g, ' $1').toLowerCase().replace(/^./, letter => letter.toUpperCase());
}
